import { render, staticRenderFns } from "./LeadingOthersCard.vue?vue&type=template&id=51c9e6aa&scoped=true&"
import script from "./LeadingOthersCard.vue?vue&type=script&lang=js&"
export * from "./LeadingOthersCard.vue?vue&type=script&lang=js&"
import style0 from "./LeadingOthersCard.vue?vue&type=style&index=0&id=51c9e6aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c9e6aa",
  null
  
)

export default component.exports